// ** Third Party Components
import styled, { css } from "styled-components";

export const StyledSvgIconContainer = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 18px;
	margin: 0 0.5rem 0 0;

	${({ $customMargin }) =>
		$customMargin &&
		css`
			margin: ${$customMargin};
		`}

	${({ $customWidth }) =>
		$customWidth &&
		css`
			width: ${$customWidth};
		`}

	svg {
		fill: ${({ theme: { colors } }) => colors.whiteAlways};
		display: block;
		height: 1em;

		${({ $customHeight }) =>
			$customHeight &&
			css`
				height: ${$customHeight};
			`};

		${({ $customVerticalAlign }) =>
			$customVerticalAlign &&
			css`
				vertical-align: ${$customVerticalAlign};
			`};
	}
`;
const CultureIcon = ({
	customHeight,
	customMargin,
	customVerticalAlign,
	customWidth,
}) => {
	return (
		<StyledSvgIconContainer
			$customHeight={customHeight}
			$customMargin={customMargin}
			$customVerticalAlign={customVerticalAlign}
			$customWidth={customWidth}
		>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
				{/* <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--> https://fontawesome.com/icons/theater-masks?f=classic&s=solid v5.15.4*/}
				<path
					d="M206.9 245.2c-35.9 10.5-60 41.2-57.5 74.1 11.4-12.7 28.8-23.7 49.9-30.9l7.6-43.2zM95.8 295L64.1 115.5c-.3-1.6 .3-2.6 .2-2.7 57.8-32.1 123.1-49 189-49 1.6 0 3.2 .2 4.9 .2 14-13.5 31.7-22.8 51.6-26 18.9-3 38.1-4.6 57.2-5.3-10-14-24.5-24.2-41.8-27C301.3 1.9 277.2 0 253.3 0 176.7 0 101 19.4 33.2 57.1 9 70.5-3.9 98.5 1.1 126.6l31.7 179.5c14.2 80.5 136.3 142.1 204.5 142.1 3.6 0 6.8-.5 10-.8-13.5-17.1-28.9-40.5-39.5-67.6-47.6-13-106.1-51.6-111.9-84.8zm97.6-137.5c-.7-4.1-2.2-7.9-4.1-11.4-8.3 8.9-20.7 15.8-35.3 18.3-14.7 2.6-28.7 .4-39.5-5.2-.5 3.9-.6 8 .1 12.1 3.8 21.7 24.6 36.2 46.3 32.4 21.8-3.8 36.3-24.5 32.4-46.2zM606.8 120.9c-89-49.4-191.4-67.4-292-51.4-27.3 4.4-49.1 26.3-54 54.4l-31.7 179.5c-15.4 87.1 95.3 196.3 158.3 207.4 63 11.1 204.5-53.8 219.9-140.8l31.7-179.5c5-28.1-8-56.1-32.2-69.5zm-273.2 96.8c3.8-21.7 24.6-36.2 46.3-32.4 21.8 3.8 36.3 24.5 32.5 46.2-.7 4.1-2.2 7.9-4.1 11.4-8.3-8.9-20.7-15.8-35.3-18.3-14.7-2.6-28.7-.4-39.5 5.2-.5-4-.7-8 .1-12.1zm70.5 198.8c-55.7-9.8-93.5-59.3-89-112.9 20.6 25.5 56.2 46.2 99.5 53.8 43.3 7.6 83.8 .4 111.9-16.6-14.2 51.9-66.7 85.5-122.4 75.7zm130.3-151.3c-8.3-8.9-20.7-15.8-35.3-18.3-14.7-2.6-28.7-.4-39.5 5.2-.5-3.9-.6-8 .1-12.1 3.8-21.7 24.6-36.2 46.3-32.4 21.8 3.8 36.3 24.5 32.5 46.2-.7 4.1-2.2 7.9-4.1 11.4z"
					fill="#FF0202"
				/>
			</svg>
		</StyledSvgIconContainer>
	);
};

export default CultureIcon;
